import React, { useEffect, useState } from 'react';
import { AppBackdrop } from 'modules/common/components';
import { delay } from 'utils/delay';
import { useApplyProgress } from './hooks/useApplyProgress';

type ApplyProgressProps = {
  isProcessing: boolean;
};
export const ApplyProgress: React.FC<ApplyProgressProps> = ({
  isProcessing
}: ApplyProgressProps) => {
  const progress = useApplyProgress(isProcessing);

  // if progress is greater than 0 and isprocessing is false,
  // then make progress 100 for 300ms to show additional completed icon before closing progress modal
  const [open, setOpen] = useState(isProcessing);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    const setProcessing = async () => {
      if (isProcessing) {
        setOpen(true);
        setFinished(false);
      } else if (!isProcessing && progress > 0) {
        setFinished(true);
        await delay(300);
        setOpen(false);
      }
    };
    setProcessing();
  }, [isProcessing, progress]);

  return <AppBackdrop open={open} progress={finished ? 100 : progress} />;
};
